"use client"

import { t } from "@/languages/i18n"
import { UseServiceFormApplyOptions, UseServiceFormApplyReturn } from "@/types/types"
import { useRef, useState } from "react"

export const useServiceFormApply = (options: UseServiceFormApplyOptions): UseServiceFormApplyReturn => {
  const { jobDetail, locale, form } = options

  const [showAlert, setShowAlert] = useState(false)
  const [isMessageSent, setIsMessageSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState<File | undefined>()
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const handleUploadClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    fileInputRef.current?.click()
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    if (file.size > 3 * 1024 * 1024) {
      alert(t("Dung lượng tập tin phải nhỏ hơn 3MB"))
      return
    }

    setSelectedFile(file)
    form.setFieldsValue({ cvFileUpload: file })
  }

  const onFinish = async (values: any) => {
    const { fullname, phone, email, selfInstruction } = values
    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("fullname", fullname)
      formData.append("phone", phone)
      if (email) formData.append("email", email)
      if (selfInstruction) formData.append("selfInstruction", selfInstruction)
      // Trang tuyển dụng chỉ thuộc tamdagroup.eu — cố định domain, không suy ra từ host (tránh ra tamdamedia.eu)
      formData.append("domain", "tamdagroup.eu")
      if (jobDetail?.id != null) formData.append("career", String(jobDetail.id))
      if (selectedFile) formData.append("cv", selectedFile)

      // Một request duy nhất: server lo upload CV → lưu hồ sơ → gửi mail
      const response = await fetch("/api/career-registration", { method: "POST", body: formData })
      if (!response.ok) throw new Error("Failed to submit career registration")

      setIsMessageSent(true)
      form.resetFields()
      setSelectedFile(undefined)
    } catch (e) {
      console.error(e)
      setIsMessageSent(false)
    } finally {
      setLoading(false)
      setShowAlert(true)
    }
  }

  return {
    showAlert,
    isMessageSent,
    loading,
    selectedFile,
    fileInputRef,
    handleUploadClick,
    handleFileChange,
    onFinish,
  }
}
